const menu_items = [
   {
      name:'general.dashboard.title',
      link:'/',
      icon:'fa fa-tachometer',
			requiresPermissions: [
                              ]
   },
   {
      name:'general.companies.title',
      link:'/companies',
      //link:'/companies?filters[type]=final',
      icon:'fab fa-black-tie',
			requiresPermissions: [
                              'company',
                              ]
   },
   {
      name:'general.users.title',
      icon:'fa fa-id-card',
			requiresPermissions: [
                              'users',
                              'roles',
                              'welders',
                              ],
      child:[
         {
            name:'general.roles.title',
            link:'/users/roles',
            icon:'fa fa-angle-double-right',
						requiresPermissions: [
                                       'roles'
                                       ]
         },
         {
            name:'general.users.company_users.title',
            link:'/users',
            icon:'fa fa-angle-double-right',
						requiresPermissions: [
                                       'users'
                                       ]
         },
         {
            name:'general.users.welders.title',
            link:'/users/welders',
            icon:'fa fa-angle-double-right',
						requiresPermissions: [
                                       'welders'
                                       ]
         }
      ]
   },
   {
      name:'general.projects.title',
      link:'/projects',
      icon:'fas fa-project-diagram',
			requiresPermissions: [
                              'project'
                              ]
   },
];

export default menu_items;

//var tmp = require('./role/company_admin');

//export default tmp.default;



// WEBPACK FOOTER //
// ./src/menu/default.js